import { IconBellRinging, IconX } from "@tabler/icons-react";
import { useEffect, useState } from "react";
import { pushState } from "../push";
import { useSession } from "../session";

const DISMISSED = "noticesBannerDismissed";

/** A soft nudge on the trip page (holder, before or during the trip) to install the app and enable notifications; hidden once subscribed or dismissed. */
export function NoticesBanner() {
  const { t } = useSession();
  const [show, setShow] = useState(false);

  useEffect(() => {
    let alive = true;
    try {
      if (localStorage.getItem(DISMISSED) === "1") return;
    } catch {
      // Storage blocked: show it; dismissal lasts the session only.
    }
    pushState()
      .then((state) => {
        if (alive && state !== "subscribed") setShow(true);
      })
      .catch(() => undefined);
    return () => {
      alive = false;
    };
  }, []);

  if (!show) return null;

  const dismiss = () => {
    setShow(false);
    try {
      localStorage.setItem(DISMISSED, "1");
    } catch {
      // ignore
    }
  };

  return (
    <div className="install-banner notices-banner" role="region" aria-label={t("noticesBannerTitle")}>
      <IconBellRinging size={28} stroke={1.5} className="install-icon" />
      <div className="install-text">
        <strong>{t("noticesBannerTitle")}</strong>
        <span className="muted">{t("noticesBannerBody")}</span>
      </div>
      <div className="install-actions">
        <a href="/account#notices" className="button button-primary button-small">
          {t("noticesBannerAction")}
        </a>
        <button type="button" className="icon-button" aria-label={t("notNow")} onClick={dismiss}>
          <IconX size={18} />
        </button>
      </div>
    </div>
  );
}
